(function () {
	angular
		.module('trackeye')
		.factory('RealtimeService', RealtimeService);

	RealtimeService.$inject = ['C4ApiService', 'HttpQueue', 'FlexEvent'];

	function RealtimeService(api, HttpQueue, FlexEvent) {
		var exports = {};

		exports.toggleAlarms = function(devices, should_disable) {
			devices.forEach(function(device) {
				HttpQueue.add('realtime-get-all-eventhandlers', {
					url: api.getUrl('/units/'+device.getNodeId()+'/flexws/eventhandler'),
					method: 'get'
				});
			});

			HttpQueue.promise('realtime-get-all-eventhandlers').then(function(xhrs) {
				var countEvents = 0;
				xhrs.forEach(function(xhr) {
					xhr.data.forEach(function(event) {
						countEvents++;
						var fEvent = new FlexEvent(event);
						fEvent.active = should_disable ? 0 : 1;

						HttpQueue.add('realtime-toggle-all-eventhandlers', {
							method: 'PUT',
							url: xhr.config.url,
							data: fEvent.toBody(),
							params: {
								uuid: fEvent.getUuid()
							}
						});
					});
				});

				if (!countEvents) {
					HttpQueue.reject('realtime-toggle-all-eventhandlers', 'no-eventhandlers');
				}
			});

			return HttpQueue.promise('realtime-toggle-all-eventhandlers');
		}

		exports.copyConfiguration = function(accountCfg, cfgReference) {
			var account_rev = parseInt(accountCfg.get('rev') || 1),
				current_rev = parseInt(cfgReference.get('rev'));

			if (account_rev === current_rev) {
				console.log('no mpl conf migration needed');
				cfgReference.copy(accountCfg);
			} else if (account_rev < current_rev) {
				console.log('mpl conf is an older revision, migration needed...');
				doMigration(accountCfg, cfgReference)
			} else {
				console.error('mpl conf revision numbers mismatch');
			}
		};

		function doMigration(accountCfg, cfgReference) {
			if ((accountCfg.get('rev') || 1) === 1) {
				toRev2(accountCfg);
			}

			if (accountCfg.get('rev') === 2) {
				toRev3(accountCfg);
			}

			cfgReference.copy(accountCfg);
			cfgReference.save();
		}

		function toRev2(accountCfg) {
			var _settings = {
				trace: accountCfg.get('trace') || 100,
				duration: accountCfg.get('rapidmode.duration') || 3600,
				labels: {
					visible: true,
					name: true,
					ts: true,
					speed: true
				}
			};

			var _groups = accountCfg.get('groups');

			for (var i in _groups) {
				delete _groups[i].is_loading;
			}

			accountCfg.unset('rapidmode');
			accountCfg.unset('trace');

			accountCfg.set('rev', 2);
			accountCfg.set('settings', _settings);
			accountCfg.set('groups', _groups);
			
			console.log('migrated mpl conf to rev2');
		}

		function toRev3(accountCfg) {
			var _groups = accountCfg.get('groups');

			for (var i in _groups) {
				_groups[i].alarms_disabled = false;
			}

			accountCfg.set('rev', 3);
			accountCfg.set('groups', _groups);

			console.log('migrated mpl conf to rev3');
		}

		return exports;
	}
})();